module.exports = __webpack_public_path__ + "img/rule_1.3947ec52.png";